var $43993547bd42ef6e$exports = {};
$43993547bd42ef6e$exports = {
  "alert": "Figyelmeztet\xE9s",
  "dismiss": "Elutas\xEDt\xE1s"
};
export { $43993547bd42ef6e$exports as default };